export default function Features() {
  const featureList = [
    {
      icon: 'ri-smartphone-line',
      title: '下拉式阅读',
      description: '适配手机与电脑屏幕，流畅的下拉式漫画阅读体验，无需翻页，一气呵成。',
    },
    {
      icon: 'ri-database-2-line',
      title: '海量漫画资源',
      description: '国漫、日漫、韩漫应有尽有，覆盖热血、恋爱、玄幻、搞笑等全品类漫画类型。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速更新',
      description: '同步各大漫画平台最新连载，每日定时更新，让你第一时间追更喜欢的漫画。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '完全免费',
      description: '所有漫画资源全部免费阅读，无隐藏收费，无强制广告，纯粹享受阅读乐趣。',
    },
    {
      icon: 'ri-bookmark-line',
      title: '智能收藏',
      description: '一键收藏喜爱的漫画，自动记录阅读进度，下次继续阅读不用从头开始。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '社区互动',
      description: '与百万漫迷交流讨论，发表你的观点和吐槽，找到志同道合的漫画同好。',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择 <span className="text-primary-600">非常爱漫画</span>？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            我们致力于为广大漫迷提供最优质的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featureList.map((feature, index) => (
            <div
              key={index}
              className="group flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:bg-primary-50/30 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}